const langTags = [
  'AngularJS',
  'Apollo',
  'Assembly',
  'AWS',
  'Bootstrap',
  'C',
  'C++',
  'C#',
  'Capacitor',
  'Canvas',
  'Chai',
  'CSS',
  'Cypress',
  'Django',
  'Echo',
  'Ember.js',
  'Erlang',
  'Express.js',
  'Firebase',
  'Gatsby',
  'Git',
  'GitHub',
  'GraphQL',
  'Go',
  'Haluka',
  'Hapi',
  'Heroku',
  'HTML',
  'Jasmine',
  'Java',
  'Javascript',
  'Jest',
  'jQuery',
  'JSON',
  'Koa.js',
  'Kotlin',
  'Laravel',
  'Matlab',
  'Memcached',
  'Meteor',
  'Microsoft Azure',
  'Mocha',
  'MongoDB',
  'Mongoose',
  'Moralis',
  'MySQL',
  'Netlify',
  'Next.js',
  'Node.js',
  'Perl',
  'PHP',
  'Postgres',
  'Postman',
  'Prisma',
  'Quixote',
  'R',
  'React',
  'React Native',
  'Redis',
  'Redux',
  'Ruby',
  'Ruby on Rails',
  'Rust',
  'Sails.js',
  'Sass',
  'Sencha Touch',
  'Socket.IO',
  'Solidity',
  'SQL',
  'Svelte',
  'Tailwind',
  'Typescript',
  'Vue',
  'Vyper',
  'XML',
  'Yul',
  'Zustand',
];

export default langTags;
